const mediaQueryList = window.matchMedia("(max-width: 767.98px)")
export default mediaQueryList
